module.exports = __webpack_public_path__ + "img/solution_building3.e2be21eb.png";